export const isPrepaymentTransactionType = (transactionType) =>
  typeof transactionType === "string" &&
  transactionType.length === 20 &&
  transactionType.charAt(14) === "1";
